/**
 * P0-8b — Shared Action Result Envelope (CMC).
 * Soft≠Live: never invent receipt/proof/live; only normalize server fields.
 * Audience: tenant user|admin desks — not a SA-only module.
 */
import { operatorSay } from "./operator-say.js";

export function normalizeActionEnvelope(body, meta = {}) {
  const b = body && typeof body === "object" ? body : {};
  const env =
    (b.action_envelope && typeof b.action_envelope === "object" && b.action_envelope) ||
    (b.envelope && typeof b.envelope === "object" && b.envelope) ||
    {};
  const err = String((meta && meta.error) || "");
  const admission = String(
    env.admission ||
      b.admission ||
      (err ? "denied" : b.ok === false ? "denied" : b.ok === true ? "committed" : "queued")
  );
  return {
    ok: b.ok !== false && !err,
    actor_kind: String(env.actor_kind || b.actor_kind || (meta && meta.actor_kind) || "Human"),
    intent_id: String(env.intent_id || b.intent_id || ""),
    canonical_incident_id: String(
      env.canonical_incident_id || b.canonical_incident_id || ""
    ),
    admission,
    phase: String(env.phase || b.phase || ""),
    receipt: env.receipt != null ? env.receipt : b.receipt != null ? b.receipt : null,
    proof: env.proof != null ? env.proof : b.proof != null ? b.proof : null,
    proof_trust_grade: String(
      (env.proof && typeof env.proof === "object" && env.proof.trust_grade) ||
        env.proof_trust_grade ||
        (b.proof && typeof b.proof === "object" && b.proof.trust_grade) ||
        b.proof_trust_grade ||
        ""
    ),
    receipt_is_not_verified: true,
    policy_revision:
      env.policy_revision != null
        ? env.policy_revision
        : b.policy_rev != null
          ? b.policy_rev
          : b.policy_revision != null
            ? b.policy_revision
            : null,
    world_state_version:
      env.world_state_version != null
        ? env.world_state_version
        : b.world_state_version != null
          ? b.world_state_version
          : null,
    idempotency_key: String(env.idempotency_key || b.idempotency_key || ""),
    cancel_outcome: String(env.cancel_outcome || b.cancel_outcome || ""),
    may_paint_cancelled:
      env.may_paint_cancelled != null ? !!env.may_paint_cancelled : undefined,
    live: !!(env.live != null ? env.live : b.live),
    soft_invent: false,
    error: err,
  };
}

/** One-line honesty chip for desks (no Soft invent labels). Receipt ≠ proof. */
export function envelopeSummary(env) {
  if (!env || typeof env !== "object") return "";
  const proofObj = env.proof && typeof env.proof === "object" ? env.proof : {};
  const grade = String(env.proof_trust_grade || proofObj.trust_grade || "")
    .trim()
    .toLowerCase();
  const hasReceipt = env.receipt != null && env.receipt !== "";
  const bits = [
    env.actor_kind || "Human",
    operatorSay(env.admission, ""),
    hasReceipt ? "Receipt on file" : "",
    grade ? operatorSay(grade, "Proof") : "",
    env.live ? "Live" : "",
    operatorSay(env.cancel_outcome, ""),
  ].filter(Boolean);
  return bits.join(" · ");
}
